import PageResultModel from '@/Models/pageResultModel';
import RequestSummaryModel from '@/Models/requestSummaryModel';
import { FilteredRequestSummaryRequestDto } from '@/Models/filteredRequestSummaryRequestDto';
import { FilteredRequestSummaryResponseDto } from '@/Models/filteredRequestSummaryResponseDto';
import apiClient from '@/Services/Clients/apiClient';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import { InitialFilterCriteriaDto } from '@/VueComponents/Filter/Dtos/initialFilterCriteriaDto';
import { FilterItemDto } from '@/VueComponents/Filter/Dtos/filterItemDto';
import RequestSummaryDto from '@/Types/requestSummaryDto';

const REQUEST_SUMMARY_BASE_URL = 'api/requestSummary';

export default class RequestSummaryService {

  public static getInitialFilter = (): Promise<InitialFilterCriteriaDto> => {
    const contextData = useContextDataStore();
    return apiClient.get(`${REQUEST_SUMMARY_BASE_URL}/${contextData.userData.business.businessId}/initialFilterCriteria`);
  };

  public static getRequests = (
    filterCriteria: FilterItemDto[],
    sortField: string,
    sortOrder: string,
    page: number,
    previousRequestId: string,
    pageSize: number): Promise<PageResultModel> => {
    const contextData = useContextDataStore();

    const filteredRequest = new FilteredRequestSummaryRequestDto(
      contextData.userData.business.businessId,
      filterCriteria,
      sortField,
      sortOrder,
      page,
      pageSize);

    return apiClient.post(`${REQUEST_SUMMARY_BASE_URL}/${contextData.userData.business.businessId}`,
      filteredRequest)
      .then((serverPageResult: FilteredRequestSummaryResponseDto) => {
        const requestModels = serverPageResult.results.map((requestSummary: RequestSummaryDto) => {
          return new RequestSummaryModel(requestSummary, previousRequestId);
        });

        const pageResult = new PageResultModel(serverPageResult, requestModels);

        return pageResult;
      });
  };
}

